/* istanbul ignore file */
import * as graph from '@adc/sdk'
import houseImage from '../storyArtifacts/property-image.png'
import adglareDefaultImage from '../storyArtifacts/adglare-default-image.png'

export const listingFixture = (foreClosureListingVariant = false) =>
  foreClosureListingVariant
    ? {
        listing_id: '1506612',
        primary_photo: null,
        listing_photos_count: 0,
        listing_page_path: '',
        reserve_price: 300000.0,
        is_hot: false,
        listing_status: 'SALE_PENDING_CLEARED',
        listing_status_group: '',
        listing_status_label: 'Sale Pending',
        formatted_address: ['3752 Dare Spgs', 'Peoria, AZ 85301, USA'],
        listing_configuration: {
          product_type: 'TRUSTEE',
          asset_type: 'FORECLOSURE',
          loan_type: 'FHA',
          venue_item_number: 2,
          item_number: 2,
          mlh_seller_code: 'FRT',
          is_third_party_online: false,
          is_reserved_displayed: true,
          is_reserve_displayed: true,
          is_offer_enabled: false,
          is_direct_offer_enabled: false,
          outsourcer_code: 'TRC',
          state: 'AZ',
          transaction_type: 'LIVE',
          occupancy_status: 'VACANT',
          file_received_date: '2023-11-29T00:00:00Z',
          is_first_look_enabled: false,
          is_assign_the_bid_enabled: false,
          buyer_paths: [],
          finance_types: [],
          interior_access_allowed: false,
          buyer_premium_available: false,
          trustee_sales_channel: 'AUCTIONEERING',
          cried_by: 'AUCTIONEERING',
          is_display_estimated_value: false,
          unpaid_balance_amount: 450000.0,
          is_minimum_bid_enabled: false,
          is_implied_reserve_enabled: false,
          is_auto_canceled: false,
          is_buyers_premium_available: false,
          is_earnest_money_deposit_available: false,
          title_insurance: 'NOT_OFFERED',
          salesforce_integration_version: 0,
          is_subject_to_confirmation: false,
          is_estimated_resale_value_hidden: true,
          is_listing_agent_assigned: false,
          is_rental_estimate_hidden: false,
          is_trustee_sale: true,
        },
        seller_property: {
          street_description: '3752 DARE SPRINGS',
          country_primary_subdivision: 'AZ',
          municipality: 'PEORIA',
          postal_code: '85301',
          country_secondary_subdivision: 'Maricopa',
          state_name: 'Arizona',
        },
        listing_summary: {
          show_opening_bid: true,
          is_remote_bid_enabled: true,
        },
        open_houses: [
          {
            start_time: '02:41:00',
            end_time: '17:12:00',
            local_date: '2027-09-09',
          },
        ],
        primary_property: {
          property_id: '1234107',
          summary: {
            total_bedrooms: 2,
            total_bathrooms: 1.0,
            square_footage: 700,
            lot_size: 0.26,
            year_built: 2010,
            valuation: 40000,
            structure_type_code: 'CONDOMINIUM_UNIT',
          },
          is_currently_saved: false,
          is_newly_listed: false,
          current_user_tracking_state: {
            is_seen: false,
            is_updated: false,
          },
        },
        auction: {
          start_date: '2023-12-01T08:55:00Z',
          end_date: '',
          starting_bid: 100000.0,
          is_online: false,
          bid_instruction: {
            nos_amount: 650000.0,
          },
        },
        external_information: {
          collateral: {
            summary: [
              {
                estimated: 1500,
                high: 2125,
                type: 'rental',
              },
            ],
          },
        },
        marketing_tags: [],
        event: {
          trustee_sale: true,
        },
        venue: {
          venue_type: 'LIVE',
        },
        selling_method: {
          __typename: 'LiveAuctionSegment',
          reserve_status: 'RESERVE_MET',
          current_highest_bid: {
            bid_amount: 123456,
          },
          configuration: {
            state_deposit_rule: '$10000',
          },
        },
      }
    : {
        listing_id: '12345678',
        primary_photo: houseImage,
        listing_photos_count: 3,
        listing_page_path: 'https://www.auction.com',
        reserve_price: 200000,
        is_hot: true,
        listing_status: graph.enums.ListingStatus.SalePendingCleared,
        listing_status_group: '',
        listing_status_label: 'Sale Pending',
        formatted_address: [
          '105 Old Colonial Drive',
          'Williamsburg, VA 23188, James City County',
        ],
        listing_configuration: {
          asset_type: 'BANK_OWNED',
          product_type: graph.enums.ProductType.Reo,
          broker_commission: 1000,
          financing_available: true,
          buyer_premium_available: false,
          interior_access_allowed: true,
          occupancy_status: 'VACANT',
          is_reserve_displayed: true,
          is_first_look_enabled: true,
          is_direct_offer_enabled: false,
          is_third_party_online: false,
        },
        seller_property: {
          street_description: '531 Wava Village',
          municipality: 'West Jordan',
          country_primary_subdivision: 'UT',
          country_secondary_subdivision: 'Queens',
          postal_code: '84081',
        },
        listing_summary: {
          show_opening_bid: true,
        },
        primary_property: {
          property_id: '123456',
          summary: {
            total_bedrooms: 3,
            total_bathrooms: 2,
            square_footage: 1379,
            lot_size: 0.8,
            year_built: 1988,
            valuation: 210000,
            structure_type_code: 'SINGLE_FAMILY_HOME',
          },
          is_currently_saved: true,
          is_newly_listed: true,
          current_user_tracking_state: {
            is_seen: false,
            is_updated: false,
          },
        },
        auction: {
          start_date: '2021-08-14T16:00:00Z',
          end_date: '2021-05-15T02:15:10Z',
          starting_bid: 50000,
          is_online: true,
          bid_instruction: {
            nos_amount: 1234,
          },
        },
        external_information: {
          collateral: {
            summary: [
              {
                estimated: 1500,
                high: 2125,
                type: 'rental',
              },
            ],
          },
        },
        marketing_tags: [{ tag: 'NEWV' }, { tag: 'PRCD' }, { tag: 'GOTO' }],
        event: {
          trustee_sale: true,
        },
        venue: {
          venue_type: graph.enums.VenueType.Live,
        },
        selling_method: {
          __typename: 'OnlineAuctionSegment',
          reserve_status: 'RESERVE_MET',
          current_highest_bid: {
            bid_amount: 123456,
          },
        },
      }

export const sparkOfferListingFixture = () => {
  const defaultFixture = listingFixture(true)
  delete defaultFixture.selling_method
  return {
    ...defaultFixture,
    attribution_source: {
      origin_code: graph.enums.AttributionSourceType.SparkOffer,
    },
    listing_configuration: {
      ...defaultFixture.listing_configuration,
      asset_type: graph.enums.AssetType.PrivateSeller,
    },
    valuation: {
      seller_current_value_amount: 200000,
    },
    strategy: {
      selling_method_attributes: {
        online_segment_type: 'SEALED_BID',
      },
    },
  }
}

export const adglareConfigurationFixture = () => ({
  htmlOverride: adglareHtmlOverride,
  main_photo: adglareDefaultImage,
  main_text: 'Test main text',
  sub_text: 'Test sub text',
  buttons: [
    {
      text: 'test button text',
      role: 'primary',
      link: 'auction.com',
    },
  ],
})

export const adglareHtmlOverride = `<!DOCTYPE html>
<html>
<head>
  <style>
    .html-override-row {
      text-align: center;
      font-size: 18px;
      padding: 16px;
      line-height: 18px;
    }

    .html-override-sub-text {
      font-size: 12px;
      font-weight: 300;
      text-align: center;
    }

    .html-override-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 275px;
      height: 35px;
      background-color: #036eb5;
      color: white;
      font-size: 15px;
      text-align: center;
      line-height: 35px;
      margin: 16px auto;
      cursor: pointer;
      border-radius: 6px;
    }

    .html-override {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }

    .html-override-image {
      height: 215px;
      width: 100%;
      background-image: url(https://auctioncom.cdn.adglare.net/t8f14b0bf/img/ugts7_mrhtnw_5ec20d10.webp);
      background-size: 350px;
      background-repeat: no-repeat;
      border-radius: 10px 10px 0 0;
    }

    .html-override-body {
      width: 100%;
      height: calc(100% - 215px);
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
    }
  </style>
</head>
<body>
  <div class="html-override">
    <div class="html-override-image"></div>
    <div class="html-override-body">
      <div class="html-override-row"><b>View a List of Now Vacant Properties Near You</b></div>
      <a id="ag-action-button-id" target="_blank" class="html-override-button" href="https://www.auction.com/residential/active_lt/vacant_os/auction_date_order,resi_sort_v2_st/y_nbs/?itm_source=adglare&itm_medium=internal&itm_campaign=vacant&itm_content=350x388">
        <p>View Vacant Properties</p>
      </a>
    </div>
  </div>
</body>
</html>
`
